import { Box } from "@mui/material";

const SurveyStatus = ({ surveyStatus, size = "12px" }) => {
  const getColorForStatus = (status) => {
    switch (status) {
      case "complete":
        return "#00ff00"; // Green
      case "incomplete":
        return "#ff0000"; // Red
      case "pending":
        return "#ffff00"; // Yellow
      default:
        return "#cccccc"; // Gray
    }
  };

  return (
    <Box
      sx={{
        width: size,
        height: size,
        backgroundColor: getColorForStatus(surveyStatus),
        margin: "1px",
        borderRadius: "50%",
      }}
      title={`Status: ${surveyStatus}`}
    />
  );
};

export default SurveyStatus;
